<template>
  <v-card class="rounded-lg bulk-mapping-card">
    <v-card-title class="d-flex justify-space-between align-start pa-6 pb-2 flex-shrink-0">
      <div>
        <div class="text-h6 font-weight-bold">{{ title }}</div>
        <div class="text-body-2 grey--text text--darken-1 mt-1">
          Tinjau kembali sebelum menyimpan
        </div>
      </div>
      <v-btn icon @click="onCancel" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-6">
      <div class="text-overline grey--text text--darken-1 mb-2">RINGKASAN MAPPING</div>

      <v-card outlined class="rounded-lg mb-4">
        <div class="d-flex justify-space-between align-center pa-3 px-4" style="background-color: #f7f8fa">
          <span>Total merchant dipilih</span>
          <span class="primary--text font-weight-bold">{{ merchants.length }} merchant</span>
        </div>
        <v-divider />
        <div class="d-flex justify-space-between align-center pa-3 px-4">
          <span>Channel Provider tujuan</span>
          <span class="font-weight-bold">{{ providerName || '—' }}</span>
        </div>
      </v-card>

      <div class="text-overline grey--text text--darken-1 mb-2">DAFTAR MERCHANT YANG AKAN DI-MAPPING</div>

      <v-card outlined class="rounded-lg">
        <button
          type="button"
          class="d-flex justify-space-between align-center pa-3 px-4 expand-toggle"
          :aria-expanded="expanded"
          @click="expanded = !expanded"
        >
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
            <span class="font-weight-medium">{{ merchants.length }} merchant dipilih</span>
            <v-chip
              v-if="overrideCount > 0"
              x-small
              color="orange lighten-4"
              text-color="orange darken-3"
              class="ml-2 font-weight-medium"
            >
              {{ overrideCount }} akan di-overwrite
            </v-chip>
          </div>
          <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </button>

        <v-expand-transition>
          <div v-show="expanded">
            <v-divider />
            <div class="merchant-list-wrapper">
              <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Merchant ID</th>
                      <th class="text-left">Nama Merchant</th>
                      <th class="text-left">Aggregator</th>
                      <th class="text-left">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in merchants" :key="row.id">
                      <td class="primary--text">{{ row.mid || '—' }}</td>
                      <td>{{ row.merchant_name || '—' }}</td>
                      <td>{{ row.aggregator_name || '—' }}</td>
                      <td>
                        <v-chip
                          small
                          :color="statusChipColor(row)"
                          :text-color="statusChipTextColor(row)"
                        >
                          {{ statusChipText(row) }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </v-expand-transition>
      </v-card>

      <v-alert
        v-if="overrideCount > 0"
        outlined
        color="orange darken-2"
        class="rounded-lg mt-4 mb-0 override-alert"
        icon="mdi-alert-outline"
      >
        <span class="text-body-2">
          <strong>{{ overrideCount }} merchant</strong> yang sudah ter-mapping ke
          provider lain akan di-<strong>overwrite</strong>.
          Pastikan sudah dikonfirmasi dengan tim terkait.
        </span>
      </v-alert>
    </v-card-text>

    <v-divider />

    <v-card-actions class="pa-6 flex-shrink-0">
      <v-btn outlined color="primary" class="rounded-lg px-6" @click="onCancel" :disabled="loading">
        Batal
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        class="rounded-lg elevation-0 px-6"
        :loading="loading"
        :disabled="loading || merchants.length < 1"
        @click="onConfirm"
      >
        <v-icon left small>mdi-check</v-icon>
        Ya, mapping sekarang
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'BulkMappingConfirm',
  props: {
    merchants: { type: Array, default: () => [] },
    providerName: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      expanded: this.merchants.length <= 5,
    };
  },
  computed: {
    title() {
      return this.merchants.length > 1
        ? 'Konfirmasi Bulk Mapping QrisTap'
        : 'Konfirmasi Mapping QrisTap';
    },
    overrideCount() {
      return this.merchants.filter((row) => this.isOverride(row)).length;
    },
  },
  watch: {
    merchants: {
      handler(newList) {
        this.expanded = (newList || []).length <= 5;
      },
      immediate: false,
    },
  },
  methods: {
    isOverride(row) {
      return Number(row.channel_provider_mapping_status) === 1;
    },
    statusChipText(row) {
      return this.isOverride(row) ? 'Overwrite' : 'Baru';
    },
    statusChipColor(row) {
      return this.isOverride(row) ? 'orange lighten-4' : 'green lighten-4';
    },
    statusChipTextColor(row) {
      return this.isOverride(row) ? 'orange darken-3' : 'green darken-3';
    },
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.bulk-mapping-card {
  display: flex;
  flex-direction: column;
}

.expand-toggle {
  background-color: #e6f3f4;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
}
.expand-toggle:focus {
  outline: 2px solid #378595;
  outline-offset: -2px;
}

.merchant-list-wrapper {
  max-height: 320px;
  overflow-y: auto;
}

.override-alert {
  background-color: #fff8e6 !important;
}
</style>
